"use client";

import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { ALGOLIA_SORT_INDEXES } from "@raumagarn/algolia";
import { clsx } from "@trydig/ui";
import { useSortBy } from "react-instantsearch";
import { Close } from "~/components/icons/16/Close";
import { SortIcon } from "~/components/icons/SortIcon";
import styles from "./SortButton.module.css";

const SORT_OPTIONS = [
	{
		value: ALGOLIA_SORT_INDEXES.default,
		label: "Standard",
	},
	{
		value: ALGOLIA_SORT_INDEXES.newest,
		label: "Nyeste",
	},
	{
		value: ALGOLIA_SORT_INDEXES.oldest,
		label: "Eldst",
	},
	{
		value: ALGOLIA_SORT_INDEXES.name_asc,
		label: "Navn A-Å",
	},
	{
		value: ALGOLIA_SORT_INDEXES.name_desc,
		label: "Navn Å-A",
	},
];

export const SortButton = () => {
	const { currentRefinement, options, refine } = useSortBy({
		items: SORT_OPTIONS,
	});

	const currentOption = SORT_OPTIONS.find((option) => option.value === currentRefinement);

	return (
		<DropdownMenu.Root modal={false}>
			<DropdownMenu.Trigger asChild>
				<button type="button" className={clsx(styles["trigger-button"], "transparent", "small")}>
					<span style={{ userSelect: "none" }}>{currentOption?.label || "Standard"}</span>
					<div className={styles["sort-icon"]}>
						<SortIcon />
					</div>
					<div className={styles["cross-icon"]}>
						<Close />
					</div>
				</button>
			</DropdownMenu.Trigger>

			<DropdownMenu.Portal>
				<DropdownMenu.Content className={styles.dropdown} side="right" align="end">
					{options.map((option) => {
						const isActive = option.value === currentRefinement;
						return (
							<DropdownMenu.Item key={option.value} onSelect={() => refine(option.value)}>
								<button
									type="button"
									className={clsx("transparent", styles.fullsize__button, isActive && "active")}
									disabled={isActive}
								>
									{option.label}
								</button>
							</DropdownMenu.Item>
						);
					})}
				</DropdownMenu.Content>
			</DropdownMenu.Portal>
		</DropdownMenu.Root>
	);
};
